export default __webpack_public_path__ + "static/media/mainpic2.222d945e.png";